import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { stylePropTypes } from '@dkrm/general-libs/theme/styles';
import SvgUri from '../../SvgUri';
import { generateUrlIcon } from '../utils';
import { getIconStyle } from './styles';
const Icon = props => {
  const {
    noFill
  } = props;
  const iconStyle = getIconStyle(props.theme);
  return /*#__PURE__*/React.createElement(View, {
    style: [props.style, {
      minWidth: props.size,
      minHeight: props.size
    }]
  }, /*#__PURE__*/React.createElement(SvgUri, {
    source: {
      uri: generateUrlIcon(props.name)
    },
    width: props.size,
    height: props.size,
    fill: noFill ? null : iconStyle.fill
  }));
};
Icon.displayName = "Icon";
Icon.propTypes = process.env.NODE_ENV !== "production" ? {
  theme: PropTypes.string,
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  style: stylePropTypes,
  noFill: PropTypes.bool
} : {};
Icon.defaultProps = {
  theme: 'tosca',
  size: 21,
  style: null,
  noFill: false
};
export default Icon;
export { getIconStyle };